import * as React from 'react';
type PageListType = {
  noOfItems: number;
  pageSize: number;
  handlePageChange: any;
};
const range = (from: number, to: number, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

type PageButtonType = {
  key: any;
  page: number;
  handlePageChange: any;
};

const PageButton = ({page, handlePageChange}: PageButtonType) => {
  return (
    <li className="pr-4">
      <button onClick={handlePageChange}>{page}</button>
    </li>
  );
};

const PageList = ({noOfItems, pageSize, handlePageChange}: PageListType) => {
  let noOfPages = Math.ceil(noOfItems / pageSize);
  return (
    <ul className="flex flex-row justify-start">
      {range(1, noOfPages, 1).map(i => (
        <PageButton handlePageChange={handlePageChange} key={i} page={i} />
      ))}
    </ul>
  );
};

export default PageList;
